module.exports = __webpack_public_path__ + "static/media/go-jek.95fefc0e.png";